// import logo from './logo.svg';
// import './App.css';
import { BrowserRouter } from "react-router-dom";
// import A from "./e-commerce-routing-site/react-components/App";
import A from "./schemes-music/App";


function App() {
  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <h1> Hello Schemes </h1>
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
    <BrowserRouter>
      <A />
    </BrowserRouter>
  );
}

export default App;
